'use strict';

import SyncError from './sync-error.js';

export default SyncError;



// WEBPACK FOOTER //
// ./app/errors/index.js